import ExitToApp from '@mui/icons-material/ExitToApp';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ExitToAppIcon(props: FixMe) {
  return <ExitToApp {...props} />;
}

export default ExitToAppIcon;
